<template>

  <div class="mb-3">

    <el-row>
      <el-col :span="6" v-if="isCalendar">
        <el-date-picker
          v-model="value.date"
          type="date"
          placeholder="Pick a day">
        </el-date-picker>

        <el-button type="text" @click="removeMe" icon="el-icon-delete" circle></el-button>
      </el-col>
      <el-col v-else :span="6">
        {{title}}
      </el-col>
      <el-col :span="3" style="padding-top: 6px">
        <el-switch v-model="value.isOpen" active-text="Is open"></el-switch>
      </el-col>
      <el-col :span="15" v-if="value.isOpen">
        <time-array-picker v-model="value.hours" />
      </el-col>
    </el-row>

  </div>

</template>
<script>
import TimeArrayPicker from './TimeArrayPicker';

export default {
  props: ['value', 'title', 'isCalendar'],
  components: {
    TimeArrayPicker
  },
  mounted() {

  },
  methods: {
    removeMe() {
      this.$emit('remove')
    }
  }
};
</script>



// WEBPACK FOOTER //
// DayHoursEditor.vue?5cfffa74